// extracted by mini-css-extract-plugin
export var active = "navDesktop-module--active--68644";
export var li = "navDesktop-module--li--89bc6";
export var link = "navDesktop-module--link--c4b8b";
export var ul = "navDesktop-module--ul--2cff1";